import { useSearchParams } from 'react-router-dom';

type UseWorkspaceTabsParams<T> = {
  defaultTab: T;
  tabParam?: string;
  resetParamsOnChange?: boolean;
  preserveParams?: string[];
};

const useWorkspaceTabs = <T extends string>({
  defaultTab,
  tabParam = 'tab',
  resetParamsOnChange = false,
  preserveParams = [],
}: UseWorkspaceTabsParams<T>) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const tab = (searchParams.get(tabParam) as T) || defaultTab;

  const buildResetParams = () => {
    const params = new URLSearchParams();
    preserveParams.forEach(key => {
      const value = searchParams.get(key);
      if (value) params.set(key, value);
    });
    return params;
  };

  const setTab = (next: T) => {
    const params = resetParamsOnChange
      ? buildResetParams()
      : new URLSearchParams(searchParams);
    params.set(tabParam, next);
    setSearchParams(params, { replace: true });
  };

  return { tab, setTab };
};

export default useWorkspaceTabs;
